export default {
  views: {
    product: {
      plans: {
        title: 'プランを選択'
      },
      cancelPolicy: {
        title: 'キャンセルポリシー'
      },
      recommendations: {
        title: '他のおすすめ'
      },
      payment: {
        plan: 'プラン',
        dateTime: '日時',
        numberOfPeople: '人数',
        totalWithTax: '合計 (税込)',
        viewPlan: 'プランを見る',
        warn: '{{unitName}}のみの購入はできません'
      },
      panels: {
        selectDate: '日付を選択',
        selectPlan: 'プランを選択',
        selectPeople: '人数を選択',
        options: 'オプション',
        profile: 'プロフィール'
      },
      auth: {
        loginOrRegister: 'ログイン / 新規登録'
      }
    },
    book: {
      title: '予約確認',
      bookingNotice: 'ご予約前にご確認ください',
      paymentConfirmation: 'お支払い前にご確認ください',
      tip: 'ご注文を確定するには、15分以内に手続きを完了してください',
      sessionInfo: '注文情報'
    },
    bookConfirm: {
      productInfo: '商品情報',
      sessionConfirmed: '確認済',
      sessionUnconfirmed: '未確認',
      paymentInfo: '支払い情報',
      paymentConfirmation: {
        warningTitle: 'キャンセルポリシーを確認してください：',
        warningText: '一度購入した商品は返金できません。',
        agreementText: '内容を確認し、同意しました'
      },
      prePaymentConfirmation: {
        title: 'お支払前の確認事項',
        checkInput: '入力内容に間違いないかご確認ください。',
        emailNotice:
          'ご注意：迷惑メール対策でドメイン指定受信設定をされている場合は、予約前に「@linktivity.co.jp」ドメインの登録をお願いします。',
        agreementText: '上記事項を確認の上、同意しました'
      },
      paymentAmount: {
        total: '支払い金額（税込）',
        details: '詳細',
        note: 'JPY以外の通貨で表示される金額は現在の為替レートに基づく推定値であり、実際の請求額とわずかに異なる場合があります。参考までにご確認ください。'
      },
      confirmPaymentDialogTitle: '支払い確認',
      participantInfo: {
        title: '参加者情報',
        dialogTitle: '参加者情報を変更',
        change: '変更',
        password: 'パスワード',
        validation: {
          passwordRequired: 'パスワードを入力してください'
        }
      },
      couponApplied: 'クーポンを適用しました',
      couponFailed: 'クーポンは利用不可',
      couponRemoved: 'クーポンが削除されました',
      couponRemoveFailed: 'クーポンの削除に失敗しました',
      actionButtons: {
        back: '前へ',
        toPayment: '支払いへ'
      }
    },
    voucher: {
      pdf: '印刷用PDF',
      html: 'バウチャーを表示'
    },
    bookingDetail: {
      title: '予約情報',
      detailInfo: '予約詳細',
      startDate: '参加日時',
      validityPeriod: '有効期限',
      voucherInfo: 'バウチャー情報',
      digitalTicket: '電子チケット',
      invoice: 'レシート・領収書',
      invoiceSend: '発行',
      invoiceSent: '領収書発行済み',
      redemption: 'Eチケットを利用',
      meetingPoint: '入場場所のご案内',
      beforeTrip: 'ご利用前の確認事項',
      bookingAction: 'キャンセル',
      cancelBooking: '予約をキャンセル',
      cancelConfirmPolicy: 'キャンセルポリシーを確認してください：',
      customerName: '予約者名',
      actualPayment: '支払額',
      refundAmount: '払い戻し金額',
      orderId: '予約ID',
      orderCompletionTime: '購入日時',
      digitalTicketValidPeriod: 'QRコードは当日のみ有効です',
      digitalTicketWaiting: '*注文確認後、電子チケットがここに表示されます',
      sending: '送信中...',
      sendToEmail: 'メールで再送信',
      cancelConfirm: '予約をキャンセルします。よろしいですか？',
      cancelFee: 'キャンセル料金',
      cancelRemarkSelect: 'キャンセル理由を選択してください',
      inclusion: '含まれるもの',
      checklist: '注意事項',
      restrictions: '参加制限',
      requirements: '参加前・参加時必要事項',
      attireItems: '参加時必要な服装・持ち物',
      otherInfo: '備考・その他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'イメージ'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: 'その他',
      CANCEL_REASON_MODIFY_BOOKING: '予約内容を変更したいため',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '誤って予約したため',
      CANCEL_REASON_DUPLICATE_BOOKING: '重複して予約してしまったため',
      CANCEL_REASON_HEALTH_CONDITION: '体調不良のため',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '交通機関の遅延・運休のため',
      CANCEL_REASON_SCHEDULE_CONFLICT: '都合が合わなくなったため',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '他施設に変更するため'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'Triplabo',
      header: {
        alt: 'Triplabo'
      },
      search: {
        placeholder: '商品を検索'
      },
      ticketList: {
        title: 'チケット一覧'
      },
      enjoyPack: {
        title: 'エンジョイパック'
      }
    }
  }
};
